export const INVALID_DOMAINS = [
    "gmail.com",
    "googlemail.com",
    "outlook.com",
    "hotmail.com",
    "live.com",
    "msn.com",
    "yahoo.com",
    "ymail.com",
    "rocketmail.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "aol.com",
    "protonmail.com",
    "zoho.com",
    "yandex.com",
    "mail.com",
    "gmx.com",
    "hey.com",
    "fastmail.com",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "rediffmail.com",
    "yahoo.co.jp",
    "mail.ru",
    "bk.ru",
    "list.ru",
    "orange.fr",
    "laposte.net",
    "web.de",
    "t-online.de",
]